/** @jsxImportSource @emotion/react */
import "./index.css";
import ReactDOM from "react-dom";
import { ThemeProvider as EmotionThemeProdiver } from "@emotion/react";
import { QueryClient, QueryClientProvider } from "react-query";
import App from "./App";
import * as Sentry from "@sentry/react";


declare module "@emotion/react" {
  export interface Theme {
    primary: string;
    secondary: string;
    black: string;
    darkGrey: string;
    grey: string;
    lightGrey: string;
    veryLightGrey: string;
    white: string;
    notCompleted: string;
    error: string;
    success: string;
  }
}

const emotionTheme = {
  primary: "#1A085C",
  secondary: "#43D869",
  black: "#040C1E",
  darkGrey: "#575757",
  grey: "#908F90",
  lightGrey: "#F6F5F6",
  veryLightGrey: "#FAFAFA",
  white: "#FFFFFF",
  notCompleted: "#E2BA2C",
  error: "#EC2300",
  success: "#4BB543",
};

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});


// Sentry initialisation
Sentry.init({
  dsn: "https://cafada1f21a07496291d75d6c66bef9c@o4506308693721088.ingest.sentry.io/4506360644567040",
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: ["localhost", /^https:\/\/api.ecovamed.com/],
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.render(
  <QueryClientProvider client={queryClient}>
    <EmotionThemeProdiver theme={emotionTheme}>
      <App />
    </EmotionThemeProdiver>
  </QueryClientProvider>,
  document.getElementById("root")
);
